import { ref, toRef, watch } from 'vue'

export const useTimeSelector = (props, { emit }) => {
    const inputTime = toRef(props, 'inputTime')
    const inputFormat = toRef(props, 'inputFormat')

    const timeList = ref([])
    const time = ref('12:00')
    const timeFormat = ref('AM')
    const showTime = ref(false)

    ;(() => {
        time.value = inputTime.value
        timeFormat.value = inputFormat.value

        _getTimeList()
    })()
    function _getTimeList() {
        for (let hour = 0; hour <= 12; hour++) {
            for (let minute = 0; minute < 60; minute += 30) {
                const formattedMinute = minute.toString().padStart(2, '0')
                let formattedHour = hour.toString().padStart(2, '0')

                if (formattedHour === '00') formattedHour = '12'
                timeList.value.push(`${formattedHour}:${formattedMinute}`)
            }
        }
    }

    watch(
        () => inputTime.value,
        (inputTime) => {
            time.value = inputTime
        }
    )
    watch(
        () => inputFormat.value,
        (inputFormat) => {
            timeFormat.value = inputFormat
        }
    )
    watch(
        () => time.value,
        (time) => {
            emit('update:inputTime', time)
        }
    )
    watch(
        () => timeFormat.value,
        (timeFormat) => {
            emit('update:inputFormat', timeFormat)
        }
    )

    const resetSetTimeAndDuration = () => {
        time.value = '12:00'
        timeFormat.value = 'AM'
        showTime.value = false
    }
    const changeTimeFormat = () => {
        timeFormat.value = timeFormat.value === 'AM' ? 'PM' : 'AM'
    }
    const setTime = (inputTime) => {
        time.value = inputTime
        showTime.value = false
    }
    const toggleTimeList = () => {
        showTime.value = !showTime.value
    }
    return {
        timeList,
        time,
        timeFormat,
        showTime,
        resetSetTimeAndDuration,
        changeTimeFormat,
        setTime,
        toggleTimeList
    }
}
